import { render, staticRenderFns } from "./PlatformUserForm.vue?vue&type=template&id=2a98a44c"
import script from "./PlatformUserForm.vue?vue&type=script&lang=js"
export * from "./PlatformUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports